import L from 'L'
import 'leaflet-sidebar'
import 'leaflet-sidebar/src/L.Control.Sidebar.css'
import 'leaflet-geosearch/src/js/l.control.geosearch.js'
import 'leaflet-geosearch/src/js/l.geosearch.provider.openstreetmap.js'
import 'leaflet-geosearch/src/css/l.geosearch.css'
import myMarker from './myMarker'
import {event} from '../../utils'
import sidebar from './sidebar'

var initMyMarker = null
module.exports = function (window)  {
  var isLogin = false
  var taiwanCenter = new L.LatLng(23.974093, 120.979903)
  // var taiwanCenter = new L.LatLng(25.034093, 121.479903)
  var map = new L.Map('map', {
    center: taiwanCenter,
    zoom: 8,
    minZoom: 4
  })

  map.addLayer(new L.Google('ROADMAP'))
  var markers = new L.MarkerClusterGroup()
  map.addLayer(markers)
  L.control.locate().addTo(map)
  new L.Control.GeoSearch({
    provider: new L.GeoSearch.Provider.OpenStreetMap()
  }).addTo(map)

  map.addControl(sidebar())

  map.taiwanCenter = taiwanCenter

  map.addPoint = (obj) => {
    var key = obj.key
    var title = obj.title
    var location = obj.location
    var isMyPoint = obj.isMyPoint
    var pic = obj.pic
    var icon = L.icon({
      iconUrl: pic,
      iconSize: [64, 64], // size of the icon
      className: 'custom_icon'
    })
    var marker = L.marker(location, {icon: icon, location_key: key, draggable: (isMyPoint) ? 'true' : null})
    marker.bindPopup('<h3>' + title + '</h3>').openPopup()
    marker.on('click', (point) => {
      event.emit('showPoint', point)
      if (initMyMarker) {
        initMyMarker.destroy()
      }
    })
    marker.on('drag', (e) => {
      event.emit('setProductLocation', e.target.getLatLng())
    })
    markers.addLayer(marker)
  }
  map.resetMarkerClusterGroup = () => {
    markers.clearLayers()
  }

  map.isLogin = (tempIs) => {
    isLogin = tempIs
  }
  map.locateSelf = () => {
    map.locate({setView: true, maxZoom: 16})
  }

  map.on('click', (e) => {
    sidebar().hide()
    if (isLogin) {
      if (initMyMarker) {
        initMyMarker.destroy()
      }
      initMyMarker = myMarker(map, e.latlng)
      event.emit('setLocationNumfunction', e.latlng)

      initMyMarker.setLatLng(e.latlng).bindPopup('<button type="button" class="mu-raised-button" id="myMarker""><span class="mu-flat-button-label">點我開始輸入資訊</span></button>').openPopup()
      document.getElementById('myMarker').addEventListener('click', () => {
        if (isLogin) {
          sidebar().show()
        } else {
          window.alert('登入後才可輸入資訊')
        }
      })
    } else {
      window.alert('登入後才可輸入資訊')
    }
  })

  map.on('locationfound', (e) => {
    // var radius = 1000  // 1公里

    L.marker(e.latlng).addTo(map)
    map.setView(e.latlng, 13)

    // L.circle(e.latlng, radius).addTo(map)
  })

  map.on('locationerror', (e) => {
    window.alert(e.message)
  })

  return map
}



// WEBPACK FOOTER //
// ./src/assets/js/map.js